import { FC, useContext } from 'react';
import { Box, Stack, Divider, IconButton, useTheme, Grid } from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import HeaderUserbox from './Userbox';
import { useScreenBreakpoints } from 'src/utils/screenBreakpoints';
import GBLogo from 'src/assets/images/gb-logo.svg';
import { HeaderWrapper } from 'src/components/StyledComponents/Navigation';
import LanguageSelector from 'src/components/LanguageSelector';
import { Logo } from 'src/components/StyledComponents/Index';

interface Props {
  menuClick: () => void;
}

const Header: FC<Props> = (props: Props) => {
  const { menuClick } = props;

  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();

  const handleMenuClick = () => {
    menuClick();
  };

  const { isSmallScreen, isMediumScreen, isLargeScreen } =
    useScreenBreakpoints();

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        backgroundColor: 'white',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.08)',
        backdropFilter: 0,
        zIndex: 10
      }}
    >
      <Stack
        direction="row"
        divider={<Divider orientation="vertical" flexItem />}
        alignItems="center"
        spacing={2}
      >
        <Grid container alignItems="left">
          <Grid item>
            <IconButton
              aria-label="delete"
              onClick={handleMenuClick}
              size={'small'}
              sx={{ cursor: 'pointer' }}
            >
              <MenuTwoToneIcon
                sx={{
                  color: theme.colors.alpha.orange[100],
                  fontSize: isSmallScreen ? '30px' : '40px'
                }}
              />
            </IconButton>
          </Grid>
          <Grid item margin="auto">
            <Logo src={GBLogo} />
          </Grid>
        </Grid>
      </Stack>
      <Box display="flex" alignItems="center">
        <LanguageSelector />
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
};

export default Header;
